export const getStatusColor = (status) => {

    const normalized = status?.trim()?.toLowerCase();


    switch (normalized) {
        // Original cases
        case "completed":
        case "approved":
        case "closed":
            return { bgColor: "#E1FFBB", textColor: "#34A853" };
        case "in progress":
        case "received":
            return { bgColor: "#e86100", textColor: "#FFFFFF" };
        case "pending":
        case "planned":
            return { bgColor: "#E2F6FF", textColor: "#0A65E4" };
        case "open":
            return { bgColor: "#E7E7EB", textColor: "#433F5E" };
        case "scheduled":
            return { bgColor: "#E3F2FD", textColor: "#1565C0" };
        case "on hold":
            return { bgColor: "#F3E5F5", textColor: "#6A1B9A" };
        case "urgent":
            return { bgColor: "#FF7578", textColor: "#CD2227" };
        case "resolved":
            return { bgColor: "#D1FADF", textColor: "#027A48" };
        case "delayed":
            return { bgColor: "#FF383C33", textColor: "#FF383C" };
        case "avg resolution time":
            return { bgColor: "#E2F6FF", textColor: "#0A65E4" };
        case "to do":
            return { bgColor: "#D0CFD7", textColor: "#433F5E" };
        case "low":
            return { bgColor: "#E2F6FF", textColor: "#0A65E4" };
        case "medium":
            return { bgColor: "#FEF0C7", textColor: "#FFB200" };
        case "high":
            return { bgColor: "#FFD7D8", textColor: "#FF383C" };
        case "very high":
            return { bgColor: "#FF7578", textColor: "#FFFFFF" };
        case "active":
            return { bgColor: "#E2F6FF", textColor: "#0A65E4" }; 
        
        default:
            return { bgColor: "#E0E0E0", textColor: "#424242" };
    }
};
